import React from "react";

import useAuth from "../../routes/login/AuthContext";
import { TableCell } from "../../UI/TableCell";
import { TableHead } from "../../UI/TableHead";
import { TableRow } from "../../UI/TableRow";
import { HelpTooltip } from "../HelpTooltip";

const ENABLE_ACCESS_HELP_TITLE = "Enabled Access";
const ENABLE_ACCESS_HELP_CONTENT =
  "If this is enabled then residents will be imported and invited to RoomSync as soon as their lease is approved by the leasing office.";

const MAPPING_HELP_TITLE = "Mapping";
const MAPPING_HELP_CONTENT =
  "This exact value must be used in the integration file sent to RoomSync in order for a user to be imported into the corresponding RoomSync Floor Plan.";

export const IntegrationTableHead = () => {
  const { isSuperAdmin } = useAuth();

  return (
    <TableHead>
      <TableRow>
        <TableCell>RoomSync Floor Plan</TableCell>
        <TableCell>
          <HelpTooltip title={MAPPING_HELP_TITLE} text={MAPPING_HELP_CONTENT}>
            Mapping
          </HelpTooltip>
        </TableCell>
        <TableCell>
          <HelpTooltip title={ENABLE_ACCESS_HELP_TITLE} text={ENABLE_ACCESS_HELP_CONTENT}>
            Enabled Access
          </HelpTooltip>
        </TableCell>
        <TableCell>Mapping Type</TableCell>
        <TableCell>External Id</TableCell>
        <TableCell>Season Id</TableCell>
        <TableCell>Grouping</TableCell>
        {isSuperAdmin() && <TableCell />}
      </TableRow>
    </TableHead>
  );
};
